var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 300,
    viewBox: "0 0 900 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7964_27584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M604.974 306.086C563.362 277.331 802.894 283.672 807.111 237.095C876.895 175.26 529.113 123.322 331.133 198.052C236.376 247.248 133.017 173.657 90.0003 212C43.4903 257.082 115.67 340.338 181.416 349.817C242.176 349.817 544.859 383.738 544.859 383.738C590.108 378.252 643.497 335.187 604.974 306.086Z",
    fill: "url(#paint0_linear_7964_27584)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 476,
    cy: 234.238,
    rx: 44,
    ry: 9.5,
    fill: "#E3E6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.588 65.1125C611.094 44.5697 620.008 52.978 622.277 59.75C621.276 63.2582 618.701 75.0317 616.405 94.0599C613.535 117.845 586.702 114.558 583.16 129.335C579.618 144.112 564.551 132.813 556.052 156.821C547.552 180.828 514.314 177.907 525.169 175.878C536.024 173.849 530.534 149.136 535.965 129.023C541.396 108.911 552.013 121.872 576.086 101.596C600.159 81.3206 571.705 90.791 593.588 65.1125Z",
    fill: "#E1E5EE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.608 79.6597C598.83 90.9802 581.678 117.158 559.292 131.307C531.309 148.992 548.297 158.271 538.486 167.578C528.674 176.885 528.876 177.677 519.774 180.209",
    stroke: "url(#paint1_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.023 86.5856C556.916 69.1451 564.374 73.3203 567.117 77.588C567.091 80.1998 567.525 88.8209 569.468 102.41C571.896 119.397 553.458 122.067 553.797 132.945C554.136 143.823 542.061 138.781 540.787 156.959C539.513 175.137 516.884 179.241 523.731 175.837C530.577 172.432 522.422 156.344 522.366 141.427C522.31 126.51 531.731 133.521 544.038 115.055C556.345 96.5895 539.156 108.386 549.023 86.5856Z",
    fill: "#E1E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.002 94.6182C557.225 103.516 550.595 124.79 538.292 138.706C522.913 156.1 535.898 159.389 531.072 167.637C526.246 175.885 526.525 176.396 520.935 179.826",
    stroke: "url(#paint2_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.776 137.676C567.69 136.551 568.002 136.86 567.954 138.03C570.873 144.105 570.17 156.03 567.127 163.579C563.247 173.201 551.951 168.824 548.776 174.605C545.601 180.386 540.305 173.977 533.954 183.062C527.604 192.147 513.484 187.206 518.426 187.573C523.367 187.939 523.717 176.993 528.303 169.193C532.889 161.393 536.068 167.999 548.773 162.217C561.477 156.435 548.065 157.21 560.416 148.924C566.694 144.712 567.87 140.067 567.954 138.03C567.896 137.909 567.837 137.791 567.776 137.676Z",
    fill: "#E7ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.597 156.237C559.833 160.323 549.482 169.347 538.189 172.757C524.072 177.019 530.426 182.799 525.133 185.592C519.839 188.384 519.84 188.738 515.604 188.778",
    stroke: "url(#paint3_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7 107.132C161.016 78.0141 174.715 68.8487 184.275 67.9057C188.575 70.2703 203.24 77.1794 227.501 85.8981C257.828 96.7966 245.467 130.994 263.781 140.072C282.095 149.15 262.759 165.516 291.688 183.863C320.617 202.21 306.816 244.916 307.412 230.074C308.008 215.231 273.956 215.016 249.213 201.861C224.471 188.706 244.651 178.674 225.287 141.026C205.923 103.379 209.805 143.528 182.7 107.132Z",
    fill: "#E1E5EE",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.079 97.0459C218.189 108.018 247.369 138.362 259.204 171.96C273.998 213.957 291.262 194.465 300.522 210.122C309.782 225.78 310.881 225.752 311.47 238.447",
    stroke: "url(#paint4_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.483 172.005C176.983 156.424 184.695 147.896 191.114 145.581C194.531 146.398 205.965 148.415 224.366 149.945C247.368 151.857 245.338 176.834 259.703 179.653C274.068 182.472 263.834 196.793 287.287 203.917C310.74 211.041 309.333 241.943 306.923 231.945C304.513 221.946 280.972 227.812 261.395 223.41C241.819 219.008 253.839 208.76 233.318 187.082C212.798 165.405 223.109 191.483 197.483 172.005Z",
    fill: "#E1E5EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.01 161.333C222.144 166.333 248.05 181.41 262.605 201.716C280.799 227.099 289.008 211.06 298.375 219.862C307.742 228.665 308.496 228.452 311.315 236.81",
    stroke: "url(#paint5_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.099 162.74C268.598 162.516 269.098 162.2 270.617 162.613C279.458 160.609 294.884 165.108 303.869 171.363C315.321 179.336 306.193 192.835 312.821 198.732C319.449 204.63 309.456 209.651 319.463 220.704C329.47 231.756 318.756 248.788 320.719 242.419C322.682 236.049 308.435 232.307 299.583 223.953C290.731 215.6 300.347 213.414 296.577 195.021C292.807 176.627 289.799 194.446 282.64 175.765C279.001 166.27 273.263 163.334 270.617 162.613C270.441 162.653 270.269 162.695 270.099 162.74Z",
    fill: "#E7ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.183 173.791C297.412 179.951 306.139 196.231 307.221 212.062C308.574 231.851 318.06 225.252 320.134 233.031C322.207 240.81 322.672 240.916 321.453 246.482",
    stroke: "url(#paint6_linear_7964_27584)",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.4334,
    transform: "matrix(1 0 0 -1 644.446 90.4777)",
    fill: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 68.6007,
    transform: "matrix(1 0 0 -1 422.488 140.786)",
    fill: "url(#paint7_linear_7964_27584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.189 258.778C393.801 261.166 389.929 261.166 387.542 258.778C385.154 256.39 385.154 252.519 387.542 250.131C389.929 247.743 393.801 247.743 396.189 250.131C398.577 252.519 398.577 256.39 396.189 258.778ZM398.298 260.887C394.745 264.44 388.985 264.44 385.433 260.887C381.88 257.335 381.88 251.575 385.433 248.022C388.985 244.469 394.745 244.469 398.298 248.022C401.851 251.575 401.851 257.335 398.298 260.887Z",
    fill: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M401.748 254.455C401.748 256.102 403.084 257.437 404.731 257.437L410.214 257.437C411.862 257.437 413.197 256.102 413.197 254.455C413.197 252.807 411.862 251.472 410.214 251.472L404.731 251.472C403.084 251.472 401.748 252.807 401.748 254.455Z",
    fill: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.4334,
    transform: "matrix(1 0 0 -1 422.433 158.172)",
    fill: "#9DA6BF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.4334,
    transform: "matrix(1 0 0 -1 382.433 175.172)",
    fill: "#9DA6BF",
    fillOpacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.97 66.6144C540.856 71.6135 540.502 78.2668 537.215 86.1183C533.932 93.9609 527.758 102.906 519.171 112.393C502.002 131.361 475.269 152.406 443.037 171.015C410.805 189.624 379.212 202.254 354.201 207.638C341.692 210.331 330.858 211.206 322.425 210.128C313.982 209.049 308.043 206.028 305.157 201.029C302.27 196.03 302.624 189.377 305.911 181.525C309.194 173.683 315.368 164.737 323.955 155.251C341.124 136.283 367.858 115.238 400.09 96.6285C432.322 78.0193 463.914 65.3899 488.926 60.0052C501.434 57.3122 512.268 56.4376 520.702 57.5157C529.145 58.595 535.083 61.6154 537.97 66.6144Z",
    stroke: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.741 134.364L323.321 125.308C324.024 125.069 324.806 125.288 325.299 125.861L340.446 143.471L355.1 138.479C355.51 138.339 355.958 138.565 356.101 138.983C356.244 139.402 356.027 139.854 355.617 139.994L313.911 154.203C312.765 154.593 311.49 154.26 310.655 153.351L296.011 137.399C295.097 136.402 295.484 134.792 296.741 134.364Z",
    fill: "#FFE999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.335 141.683C316.032 142.382 317.079 142.459 317.674 141.857C318.269 141.255 318.187 140.201 317.49 139.502C316.793 138.803 315.746 138.724 315.151 139.327C314.556 139.929 314.638 140.984 315.335 141.683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 65.0142,
    width: 52.5939,
    height: 31.9901,
    transform: "rotate(-39.2494 509 65.0142)",
    fill: "#D9E3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 65.0142,
    width: 52.5939,
    height: 4.33764,
    transform: "rotate(-39.2494 509 65.0142)",
    fill: "#D4DCF0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.819 67.7276L550.829 39.9404L552.888 42.4597L518.877 70.2469L516.819 67.7276ZM521.278 73.1842L555.289 45.397L557.347 47.9163L523.337 75.7035L521.278 73.1842ZM559.748 50.8578L525.738 78.6449L527.796 81.1642L561.806 53.3771L559.748 50.8578Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.481 64.253C513.075 63.7559 512.343 63.6822 511.846 64.0883C511.349 64.4945 511.275 65.2267 511.681 65.7239C512.087 66.221 512.82 66.2947 513.317 65.8886C513.814 65.4824 513.888 64.7501 513.481 64.253ZM516.182 62.047C515.776 61.5498 515.044 61.4761 514.547 61.8823C514.049 62.2884 513.976 63.0207 514.382 63.5178C514.788 64.0149 515.52 64.0887 516.017 63.6825C516.515 63.2764 516.588 62.5441 516.182 62.047ZM517.247 59.6762C517.744 59.27 518.476 59.3438 518.882 59.8409C519.289 60.338 519.215 61.0703 518.718 61.4765C518.221 61.8826 517.488 61.8089 517.082 61.3117C516.676 60.8146 516.75 60.0824 517.247 59.6762Z",
    fill: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.796,
    y: 198.738,
    width: 48.1542,
    height: 29.2897,
    fill: "#F2F6F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.796,
    y: 198.738,
    width: 48.1542,
    height: 3.97148,
    fill: "#E0E7ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.768 205.192H390.979V208.171H350.768V205.192ZM350.768 211.646H390.979V214.624H350.768V211.646ZM390.978 218.1H350.767V221.078H390.978V218.1Z",
    fill: "white",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.61 200.893C350.61 200.251 350.09 199.731 349.448 199.731C348.806 199.731 348.286 200.251 348.286 200.893C348.286 201.535 348.806 202.056 349.448 202.056C350.09 202.056 350.61 201.535 350.61 200.893ZM354.098 200.893C354.098 200.251 353.577 199.731 352.935 199.731C352.293 199.731 351.773 200.251 351.773 200.893C351.773 201.535 352.293 202.056 352.935 202.056C353.577 202.056 354.098 201.535 354.098 200.893ZM356.422 199.731C357.064 199.731 357.584 200.251 357.584 200.893C357.584 201.535 357.064 202.056 356.422 202.056C355.78 202.056 355.26 201.535 355.26 200.893C355.26 200.251 355.78 199.731 356.422 199.731Z",
    fill: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.608 150.527C480.333 149.787 482.277 159.647 483.265 163.539C488.169 162.893 495.763 149.984 497.952 149.727C499.649 149.528 500.192 149.086 500.673 149.078C501.941 149.057 500.067 149.982 497.473 150.813C496.328 151.18 495.74 160.529 488.508 167.466C483.965 170.405 482.032 170.136 480.685 168.982C478.467 169.403 475.63 162.359 474.914 158.32C474.096 153.701 476.434 151.461 478.608 150.527Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M481.732 156.435C480.783 151.58 479.157 145.718 475.117 145.726C473.524 145.729 471.54 148.81 474.633 158.442C476.677 158.02 479.657 157.323 481.732 156.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.84 149.56C454.291 148.5 449.829 157.199 448.105 160.826C443.42 159.242 440.216 158.169 438.118 157.493C436.492 156.97 436.045 156.431 435.575 156.33C434.335 156.063 435.994 157.334 438.378 158.652C439.43 159.233 440.523 159.873 441.383 160.487C445.941 163.133 447.425 164.106 448.907 164.702C453.395 166.507 459.5 152.067 455.84 149.56Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.12659,
    ry: 0.481103,
    transform: "matrix(-0.752743 -0.658314 -0.658314 0.752743 435.414 156.334)",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.986 154.154C452.857 149.574 455.588 144.138 459.55 144.928C461.113 145.24 462.462 148.647 457.562 157.497C455.638 156.687 452.849 155.427 450.986 154.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M450.445 195.103C451.237 198.562 456.01 196.415 456.01 196.415C456.01 196.415 470.426 182.77 467.449 169.312C466.065 163.053 461.684 162.23 460.493 162.687C459.301 163.145 454.734 179.082 454.734 179.082C454.734 179.082 449.653 191.644 450.445 195.103Z",
    fill: "#1F2D44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.704 231.459C446.704 231.459 446.637 232.15 446.132 232.416C445.626 232.681 444.063 232.498 443.788 232.641C443.513 232.785 443.449 232.978 443.449 232.978L447.42 234.498L447.879 233.274L448.058 232.333L446.704 231.459Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.245 191.76C449.624 191.774 447.268 199.953 446.885 203.614C446.503 207.274 446.408 229.103 445.537 231.828L448.153 232.915C448.153 232.915 452.066 214.182 453.362 210.423C454.389 207.443 459.51 191.737 453.245 191.76Z",
    fill: "#1F2D44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.694 229.681C479.694 229.681 481.024 231.485 481.169 232.18C481.314 232.875 482.014 233.422 482.393 233.52C482.874 233.56 482.97 233.288 483.953 232.454C484.846 231.697 484.539 231.42 484.184 231.156C483.83 230.891 483.283 231.276 482.707 230.586C482.407 230.301 481.719 228.931 481.719 228.931L479.694 229.681Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.096 206.172C471.253 210.294 480.272 230.489 480.272 230.489L482.434 229.481C482.434 229.481 478.31 201.321 476.396 197.534C474.483 193.747 471.997 194.371 471.997 194.371C471.997 194.371 467.034 195.261 470.096 206.172Z",
    fill: "#2F405E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.989 202.662C469.629 205.809 472.001 204.359 472.001 204.359C472.001 204.359 482.505 187.516 476.225 175.245C473.305 169.539 468.858 169.849 467.821 170.593C466.783 171.337 466.389 187.91 466.389 187.91C466.389 187.91 466.349 199.515 467.989 202.662Z",
    fill: "#2F405E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.395 132.458C466.755 132.403 467.112 132.333 467.463 132.233C467.86 132.12 468.37 131.996 468.677 132.003C469.322 132.018 470.389 132.279 470.865 133.045C471.459 134 472.899 133.567 471.858 137.813C470.679 142.62 468.123 141.606 468.073 141.511C468.024 141.418 466.268 137.973 466.268 137.973C466.268 137.973 465.14 139.62 465.151 139.554C465.163 139.491 462.07 133.117 466.395 132.458Z",
    fill: "#FF7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.812 141.655L466.269 143.35C466.269 143.35 465.304 145.76 465.877 146.362C466.45 146.964 469.236 143.815 469.236 143.815L469.805 139.372L466.812 141.655Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.62 140.812C468.804 142.215 467.339 142.902 466.352 143.093L466.812 141.655L469.805 139.372L469.62 140.812Z",
    fill: "#FC8899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.308 134.155C466.951 133.672 465.489 134.59 465.267 136.023C465.17 136.646 465.08 137.429 465.056 138.286C464.998 140.346 466.022 142.355 466.938 142.358C467.855 142.362 470.401 141.037 470.523 138.112C470.599 136.306 469.732 134.663 468.308 134.155Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.844 138.34C469.84 138.794 470.131 139.164 470.495 139.165C470.859 139.167 471.158 138.799 471.163 138.345C471.167 137.89 470.876 137.521 470.512 137.519C470.148 137.518 469.849 137.886 469.844 138.34Z",
    fill: "#FFC3B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.513 137.518C470.513 137.518 469.391 137.595 469.119 136.819C468.848 136.044 467.698 134.268 465.773 134.569C463.849 134.87 467.643 133.327 467.788 133.354C467.933 133.38 469.673 133.683 469.673 133.683C469.673 133.683 470.81 135.048 470.836 135.181C470.862 135.313 471.006 136.728 471.006 136.728L470.513 137.518Z",
    fill: "#FF7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.453 143.277C463.562 143.279 458.524 145.135 456.487 146.472C456.487 146.472 458.032 158.842 456.863 168.537C457.543 170.913 454.162 178.407 454.162 178.407L477.203 178.73C477.203 178.73 474.872 160.657 475.746 157.738C476.619 154.819 476.693 146.529 476.693 146.529C476.693 146.529 476.501 144.623 472.23 143.871C470.239 143.52 467.473 143.275 465.453 143.277Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7964_27584",
    x1: 586.604,
    y1: 121.967,
    x2: 108.686,
    y2: 412.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEFF7",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7964_27584",
    x1: 604.406,
    y1: 78.8671,
    x2: 517.921,
    y2: 177.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7964_27584",
    x1: 558.724,
    y1: 94.107,
    x2: 516.432,
    y2: 177.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7964_27584",
    x1: 563.597,
    y1: 155.883,
    x2: 516.303,
    y2: 189.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7964_27584",
    x1: 203.979,
    y1: 97.0732,
    x2: 307.986,
    y2: 240.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7964_27584",
    x1: 210.256,
    y1: 161.546,
    x2: 306.473,
    y2: 241.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7964_27584",
    x1: 292.719,
    y1: 173.684,
    x2: 322.492,
    y2: 245.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7964_27584",
    x1: 22.8669,
    y1: 94.8976,
    x2: 104.044,
    y2: 5.71673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E3EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7964_27584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 300,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAddress);
export default __webpack_public_path__ + "static/media/noAddress.247b0fb78df1593eef252631fd88683f.svg";
export { ForwardRef as ReactComponent };